// In-page links on the hero button (href="#...") scroll smoothly to their target.
// The target is the element with that id or, failing that, the section whose ID in
// the JSON template is that name: "#shop-now" finds `shopify-section-template--…__shop-now`.
(function () {
  function findTarget(hash) {
    let id = '';
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return null;
    }
    if (!id) return null;
    return (
      document.getElementById(id) ||
      document.querySelector('.shopify-section[id$="__' + CSS.escape(id) + '"]')
    );
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a.hero-video__button[href^="#"]');
    if (!link) return;
    const target = findTarget(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });
})();
